<template>
    <div class="con" v-loading="loading">
        <div>
            <el-tabs v-model="activeName">
                <el-tab-pane :label="`${$t('lang.smartlink.general')}`" name="default">
                    <div class="text item">
                        <p style="line-height: 1;font-size: 16px;padding-bottom: 10px;">
                            {{ $t('lang.smartlink.modeConfiguration') }}</p>
                        <el-table :data="data.mode" border strip>
                            <el-table-column :label="`${$t('lang.smartlink.enable')}`">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.enabled == '1' ? '✔' : '✖' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="`${$t('lang.smartlink.uplink')}`" prop="uplink">
                                <template slot-scope="scope">
                                    <span>{{ (scope.row.uplink).join(',') }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="`${$t('lang.smartlink.downlink')}`" prop="downlink">
                            </el-table-column>
                            <el-table-column :label="`${$t('lang.Button.operation')}`">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click="modeEdit(scope.row, scope.$index)">
                                        {{ $t('lang.Button.edit') }}</el-button>
                                    <!-- <el-button type="danger" size="small" :disabled="noSname === false ? false : true"
                                        @click="modeDelete(scope.row, scope.$index)">{{ $t('lang.Button.delete') }}
                                    </el-button> -->
                                </template>
                            </el-table-column>
                        </el-table>
                        <p style="line-height: 1;font-size: 16px;padding-bottom: 10px;margin-top: 10px;">
                            {{ $t('lang.smartlink.connectConfiguraton') }}</p>
                        <conn :nms="true" :Conn="data.Conn" @updateData="updateData" :deviceDid="deviceDid"
                            :deviceSn="deviceSn" :com='data.COM' :noSname="noSname" :vendorName="vendorName"
                            :deviceSoftwareVer="deviceSoftwareVer"></conn>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="`${$t('lang.smartlink.senior')}`" name="senior">
                    <senior :nms="true" :originalServer="originalServer" :data="data.service" v-if="data.service"
                        :deviceDid="deviceDid" :deviceSn="deviceSn" @updateData="updateData"></senior>
                </el-tab-pane>
            </el-tabs>
        </div>
        <mode-dialog ref="modeDialog" :deviceDid="deviceDid" :deviceSn="deviceSn" @updateData="updateData"
            :linkOptions="linkOptions" :noSname="noSname"></mode-dialog>
    </div>
</template>

<script>
import conn from "../SmartLink/components/Conn/index";
import senior from "../SmartLink/components/Senior/index";
import modeDialog from "../SmartLink/components/Mode/contDialog";
export default {
    name: "smartNms",
    props: ["loading", "data", "noSname", "deviceDid", "deviceSn", "vendorName", "originalServer","linkOptions", "deviceSoftwareVer"],
    data() {
        return {
            activeName: "default"
        };
    },
    components: {
        conn,
        senior,
        modeDialog
    },
    methods: {
        updateData() {
            this.$emit("GetConfig", { name: "网管服务" });
        },
        modeEdit(row, index) {
            this.$refs.modeDialog.show(row, index);
        },
    }
};
</script>
<style src='../common.css' scoped>
</style>